import React from 'react';
import { Container } from 'react-bootstrap';
import List from './components/List';
import Header from '../../components/Header';
import Banner from '../../components/Banner';

const ListContainer = () => {
  return (
    <Container fluid>
      <Banner />
      <Header />
      <List />
    </Container>
  );
};

export default ListContainer;
